export const en = {
  weekDay: {
    abbr: ['S', 'M', 'T', 'W', 'T', 'F', 'S']
  }
};
